const APIURL = 'https://aleli.appsinnovategroup.com'
const APIURL_V2 = 'https://aleli.appsinnovategroup.com/v2/'

// --- Funciones compartidas desde ig-currency.js ---
var getPayPalCurrency = window.igCurrency.getPayPalCurrency;
var fetchRate = window.igCurrency.fetchRate;

// --- Carga dinamica del SDK ---
function loadPayPalSDK(currency) {
  return new Promise(function (resolve, reject) {
    var existing = document.getElementById('paypal-sdk');
    if (existing) existing.remove();

    var script = document.createElement('script');
    script.id = 'paypal-sdk';
    script.src = 'https://www.paypal.com/sdk/js?client-id=' + PAYPAL_CLIENT_ID + '&currency=' + currency;
    script.onload = resolve;
    script.onerror = function () { reject(new Error('PayPal SDK failed')); };
    document.head.appendChild(script);
  });
}

// --- Inicializacion con moneda correcta ---
async function initPayPalWithCurrency(containerSelector) {
  // 1. Obtener pais
  var country = localStorage.getItem('ig_country') || '';

  // Si no hay pais todavia (primera visita, fetch en curso), esperar evento
  if (!country) {
    country = await new Promise(function (resolve) {
      var timeout = setTimeout(function () { resolve(''); }, 3000);
      window.addEventListener('countryReady', function (e) {
        clearTimeout(timeout);
        resolve(e.detail);
      }, { once: true });
    });
  }

  var currency = getPayPalCurrency(country);

  // 2. Aplicar descuento si corresponde (en USD, antes de convertir)
  if (typeof Cookies !== 'undefined' && Cookies.get("discount_code") !== undefined) {
    if (Cookies.get("discount_code") == paypalData.extraDtoName && paypalData.extraDto != 0) {
      paypalData.amount = paypalData.extraDto;
    }
  }

  // 3. Convertir monto
  var usdAmount = parseFloat(paypalData.amount);
  var rate = await fetchRate(currency);
  var convertedAmount = Math.ceil(usdAmount * rate * 100) / 100;

  // 4. Preparar cart enriquecido
  var cartData = Object.assign({}, paypalData, {
    currency: currency,
    amount: convertedAmount.toFixed(2),
  });

  // 5. Cargar SDK con moneda correcta
  try {
    await loadPayPalSDK(currency);
  } catch (e) {
    console.error(e);
    resultMessage('Error al cargar PayPal. Recarga la pagina.');
    return;
  }

  // 6. Render botones
  initPayPalButtons(cartData, payerData, containerSelector);
}

// --- PayPal Buttons ---
function initPayPalButtons(cartData, payer, containerSelector) {
  window.paypal
    .Buttons({
      async createOrder() {
        try {
          var body = { cart: cartData };
          if (payer && payer.email) {
            body.cart.payer = payer;
          }

          var response = await fetch(APIURL + '?action=button', {
            method: "POST",
            body: JSON.stringify(body),
          });

          var orderData = await response.json();

          if (orderData.id) {
            return orderData.id;
          } else {
            var errorDetail = orderData?.details?.[0];
            var errorMessage = errorDetail
              ? errorDetail.issue + ' ' + errorDetail.description + ' (' + orderData.debug_id + ')'
              : JSON.stringify(orderData);
            throw new Error(errorMessage);
          }
        } catch (error) {
          console.error(error);
          resultMessage('Could not initiate PayPal Checkout...<br><br>' + error);
        }
      },
      async onApprove(data, actions) {
        try {
          var response = await fetch(APIURL + '?action=capture&id=' + data.orderID, {
            method: "POST"
          });
          var orderData = await response.json();
          console.log(orderData);

          var errorDetail = orderData?.details?.[0];

          if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
            return actions.restart();
          } else if (errorDetail) {
            throw new Error(errorDetail.description + ' (' + orderData.debug_id + ')');
          } else if (!orderData.purchase_units) {
            throw new Error(JSON.stringify(orderData));
          } else {
            var shopifyOrder = await fetch(APIURL + '?action=order&id=' + data.orderID, {
              method: "POST",
              body: JSON.stringify({ cart: cartData })
            });
            var shopifyResponse = await shopifyOrder.json();

            if (shopifyResponse.order_status_url) {
              resultMessage('Estamos terminando de procesar tu pago, por favor aguarda unos segundos...');
              window.location = shopifyResponse.order_status_url;
              return;
            }
            resultMessage('Se proceso tu pago pero hubo un error con tu pedido.');
            console.log(shopifyResponse);
          }
        } catch (error) {
          console.error(error);
          resultMessage('Ups, hubo un problema con el pago...<br><br>' + error);
        }
      },
    })
    .render(containerSelector || "#paypal-button-container");
}

// Expose for sticky cart modal — runs the full init flow (currency + SDK + render)
window.renderPayPalButtonsTo = function(selector) {
  initPayPalWithCurrency(selector);
};

// --- Guest email step / Logged-in init ---
if (paypalData.customer_id) {
  initPayPalWithCurrency();
} else {
  var emailSubmit = document.getElementById('paypal-email-submit');
  var emailInput = document.getElementById('paypal-guest-email');
  var emailError = document.getElementById('paypal-email-error');

  if (emailSubmit) {
    emailSubmit.addEventListener('click', async function () {
      var email = emailInput.value.trim();
      emailError.style.display = 'none';

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        emailError.textContent = 'Ingresa un email valido.';
        emailError.style.display = 'block';
        return;
      }

      emailSubmit.disabled = true;
      emailSubmit.textContent = 'Procesando...';

      try {
        var response = await fetch(APIURL_V2 + '?action=customerLookup', {
          method: 'POST',
          body: JSON.stringify({ email: email }),
        });
        var data = await response.json();

        if (data.customer_id) {
          paypalData.customer_id = String(data.customer_id);
          payerData.email = email;
          document.getElementById('paypal-email-step').style.display = 'none';
          document.getElementById('paypal-button-container').style.display = 'block';
          initPayPalWithCurrency();
        } else {
          emailError.textContent = data.error || 'Error al procesar el email.';
          emailError.style.display = 'block';
        }
      } catch (err) {
        emailError.textContent = 'Error de conexion. Intenta de nuevo.';
        emailError.style.display = 'block';
      }

      emailSubmit.disabled = false;
      emailSubmit.textContent = 'Continuar';
    });

    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') emailSubmit.click();
    });
  }
}

function resultMessage(message) {
  var container = document.querySelector("#result-message");
  container.style.display = 'block';
  container.innerHTML = message;
}
